"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TabButtons = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
/* eslint-disable max-lines-per-function */
const react_1 = require("react");
const atoms_1 = require("../../atoms");
const bridge_1 = require("@completeanatomy/bridge");
const device_1 = require("@completeanatomy/device");
const InfoBoxStateProvider_1 = require("../../providers/InfoBoxStateProvider");
const hooks_1 = require("../../hooks");
const useAvailableTabs_1 = require("../../hooks/useAvailableTabs");
const i18n_1 = require("@completeanatomy/i18n");
const react_router_dom_1 = require("react-router-dom");
const access_1 = require("@completeanatomy/access");
const analytics_1 = require("@completeanatomy/analytics");
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
const ui_1 = require("@completeanatomy/ui");
const TabButtonsContainer_1 = require("../../atoms/TabButtonsContainer");
const constants_1 = require("../../constants");
function TabButtons() {
    const hasUpgradedAccess = (0, access_1.useAccessCheck)(bridge_schema_1.UIAccessModifier.Restricted);
    const { isMobile } = (0, device_1.usePlatform)();
    const bridge = (0, bridge_1.useBridge)();
    const availableTabs = (0, useAvailableTabs_1.useAvailableTabs)(isMobile);
    const [{ currentTab }, dispatchInfoBoxState] = (0, InfoBoxStateProvider_1.useInfoBoxStateContext)();
    const analytics = (0, analytics_1.useAnalytics)();
    const [isAccessPopupOpen, setIsAccessPopupOpen] = (0, react_1.useState)(false);
    const navigate = (0, react_router_dom_1.useNavigate)();
    const onExplode = (0, react_1.useCallback)(() => {
        bridge === null || bridge === void 0 ? void 0 : bridge.isolateAction({ animated: true, activateExplodeIsolate: true });
        bridge === null || bridge === void 0 ? void 0 : bridge.toggleExplodeMode({
            mode: true,
            exitIsolate: true,
            animation: true,
        });
        navigate('/mode/isolate?cluster=true');
    }, [bridge, navigate]);
    const onButtonClick = (0, react_1.useCallback)((type) => () => {
        const hasAvailableType = type === bridge_schema_1.InfoBoxTabType.Description || type === bridge_schema_1.InfoBoxTabType.Models;
        analytics.log('InfoboxMenuItemSelected', {
            toolType: type,
        });
        if (isMobile && !hasAvailableType && !hasUpgradedAccess) {
            setIsAccessPopupOpen(true);
            return;
        }
        if (currentTab === type) {
            dispatchInfoBoxState((0, hooks_1.selectTab)(type));
            bridge === null || bridge === void 0 ? void 0 : bridge.toggleInfoBoxTab(bridge_schema_1.InfoBoxTabType.None);
            return;
        }
        if (type === bridge_schema_1.InfoBoxTabType.Explode) {
            onExplode();
            return;
        }
        dispatchInfoBoxState((0, hooks_1.selectTab)(type));
        bridge === null || bridge === void 0 ? void 0 : bridge.toggleInfoBoxTab(type);
    }, [
        isMobile,
        hasUpgradedAccess,
        currentTab,
        dispatchInfoBoxState,
        bridge,
        analytics,
        onExplode,
    ]);
    const onPreviousTab = () => {
        const currentTabIndex = availableTabs.indexOf(currentTab);
        const previousTab = availableTabs[Math.max(0, currentTabIndex - 1)];
        if (previousTab) {
            onButtonClick(previousTab)();
        }
    };
    const onNextTab = () => {
        const currentTabIndex = availableTabs.indexOf(currentTab);
        const nextTab = availableTabs[Math.min(currentTabIndex + 1, availableTabs.length - 1)];
        if (nextTab) {
            onButtonClick(nextTab)();
        }
    };
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(TabButtonsContainer_1.TabButtonsContainer, { "$isMobile": isMobile, horizontal: true, role: "tablist", "data-e2e": 'TabButtons_TabButtonsContainer', children: [availableTabs.map(type => {
                        const key = (0, constants_1.getTabKeyByType)(type);
                        const selected = type === currentTab;
                        return ((0, jsx_runtime_1.jsx)(atoms_1.TabButton, { onClick: onButtonClick(type), iconName: (0, constants_1.getTabIconByType)(type), areaLabel: selected ? `${key} selected` : key, selected: selected, label: (0, i18n_1.Localized)(i18n_1.Strings.infoBox.tabs[key.toLowerCase()]), "data-e2e": 'TabButtons_TabButton' }, key));
                    }), (0, jsx_runtime_1.jsx)(ui_1.ArrowLeft, { hidden: isMobile || currentTab === availableTabs[0], onClick: onPreviousTab, "data-e2e": 'TabButtons_ArrowLeft' }), (0, jsx_runtime_1.jsx)(ui_1.ArrowRight, { hidden: isMobile || currentTab === availableTabs[availableTabs.length - 1], onClick: onNextTab, "data-e2e": 'TabButtons_ArrowRight' })] }), (0, jsx_runtime_1.jsx)(access_1.AccessPopup, { isOpen: isAccessPopupOpen, onClose: () => setIsAccessPopupOpen(false), "data-e2e": 'TabButtons_AccessPopup' })] }));
}
exports.TabButtons = TabButtons;
